import React from 'react';

const HorseIcon = (props) => {
  return (
    <img
      alt="Stajnia"
      src="/static/images/icons/place_types/horse.svg"
      {...props}
    />
  );
};

export default HorseIcon;
